<template>
  <ExclamationTriangleIcon :class="props.class || 'w-4 h-4'" />
</template>
<script setup lang="ts">
import { ExclamationTriangleIcon } from '@heroicons/vue/24/outline'

const props = defineProps<{
  class?: string;
}>();
</script>